import React, { useState } from "react"
import { Link, useLocation, useParams } from "react-router-dom"
import moment from "moment"

import loader from "@/assets/img/loader.svg"
import brandImage from "@/assets/img/login/brand.svg"

import "@/assets/scss/pages/login.scss"

import Api from "../../../_helpers/Api"
import { useLanguageContext } from "../../../_providers/Language"
import { trans } from "../../../_providers/Translation"
import { getErrorMessage } from "./helpers"

function ForgottenPassword() {
  const languages = useLanguageContext()
  const location = useLocation()
  const params = useParams()

  const searchParams = new URLSearchParams(location.search)

  const role = params.role === "admin" ? "admin" : "partners"

  const [lang, setLang] = useState(searchParams.get("lang") || "en")

  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = (e) => {
    e.preventDefault()

    if (loading) {
      return
    }

    setLoading(true)
    setError(null)

    Api.post("forgotten-password", {
      email: email,
      is_admin: role === "admin",
    })
      .then(() => {
        setSent(true)
      })
      .catch((err) => {
        setError(
          getErrorMessage(err, trans("login.forgottenPassword.fail", {}, lang))
        )
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleLangChange = (e) => {
    setLang(e.target.value)
  }

  return (
    <section id="login">
      <img src={brandImage} alt="brand" />

      <form onSubmit={handleSubmit} className="password-reset">
        <div className="top">
          <Link to={"/login/" + role} className="back">
            {trans("login.twoFactor.back", {}, lang)}
          </Link>
          <select value={lang} onChange={handleLangChange}>
            {languages.map((language) => (
              <option key={language.id} value={language.code}>
                {language.name}
              </option>
            ))}
          </select>
        </div>

        <h1>{trans("login.forgottenPassword.head", {}, lang)}</h1>

        {sent ? (
          <>
            <div className="message success">
              {trans("login.forgottenPassword.sent", { email: email }, lang)}
            </div>
            <div className="row">
              <div className="col actions">
                <Link to={"/login/" + role} className="button button-primary">
                  {trans("login.forgottenPassword.backToLogin", {}, lang)}
                </Link>
              </div>
            </div>
          </>
        ) : (
          <>
            <p>{trans("login.forgottenPassword.description", {}, lang)}</p>
            <div className="row">
              <div className="col">
                <label>{trans("login.email", {}, lang)}</label>
                <input
                  type="text"
                  inputMode="email"
                  name="email"
                  required
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={trans("login.email", {}, lang)}
                  className={error ? "validate" : ""}
                />
              </div>
            </div>

            {error && <div className="message error">{error}</div>}

            <div className="row">
              <div className="col actions">
                {loading ? (
                  <img src={loader} alt="loading" />
                ) : (
                  <button className="button button-primary">
                    {trans("login.forgottenPassword.button", {}, lang)}
                  </button>
                )}
              </div>
            </div>
          </>
        )}
      </form>

      <p>© EUS {moment().format("YYYY")}. All rights reserved.</p>
    </section>
  )
}

export default ForgottenPassword
